import React, { memo } from "react";
import { useCountdownDigit } from "./index.hooks";
import { Box, Typography } from "@mui/material";

type CountdownDigitProps = {
  digit: number;
};

const rotationAngle = 15;

export const CountdownDigit = memo(({ digit }: CountdownDigitProps) => {
  const {} = useCountdownDigit();

  return (
    <Box
      sx={{
        backgroundColor: "rgba(255,0,0,0.6)",
        borderRadius: "20px",
        position: "absolute",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        top: "50%",
        left: "50%",
        transform: `translate(-50%,-50%) rotate(-${rotationAngle}DEG)`,
        zIndex: 10,
        width: {
          xs: 120,
          md: 200,
        },
        height: {
          xs: 120,
          md: 200,
        },
      }}
    >
      <Typography
        variant="h1"
        sx={{
          color: "#FFF",
          fontSize: {
            xs: 80,
            md: 170,
          },
          fontWeight: "bold",
          transform: `rotate(${rotationAngle}DEG)`,
        }}
      >
        {digit}
      </Typography>
    </Box>
  );
});
